export enum PaymentType {
  CreditCard,
  VNPay,
  BankTransfer,
}
